import styled from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background: #EBF7F0;
  border-radius: 8px;

  @media only screen (min-width: 768px) {
    padding: 11px 12px;
  }
`;

export default Wrapper(template)